/* src/app/components/toast/toast.component.scss */
.toasts {
  position: absolute;
  top: 0;
  z-index: 2000;
  width: 100%;
}
.toasts .error-toast {
  width: 100%;
  background-color: #C91A13;
  color: white;
  min-height: 42px;
  font-size: 14px;
  font-weight: 700;
  display: grid;
  align-items: center;
  line-height: 2.25em;
  grid-template-columns: 118px [icon] min-content 6px [message] auto [close] min-content 118px;
}
.toasts .error-toast .message {
  grid-area: message;
}
.toasts .info-toast {
  width: 100%;
  background-color: #2196F3;
  color: white;
  min-height: 42px;
  font-size: 14px;
  font-weight: 700;
  display: grid;
  align-items: center;
  line-height: 2.25em;
  grid-template-columns: 118px [icon] min-content 6px [message] auto [close] min-content 118px;
}
.toasts .info-toast .message {
  grid-area: message;
}
.toasts .success-toast {
  width: 100%;
  background-color: #390;
  color: white;
  min-height: 42px;
  font-size: 14px;
  font-weight: 700;
  display: grid;
  align-items: center;
  line-height: 2.25em;
  grid-template-columns: 118px [icon] min-content 6px [message] auto [close] min-content 118px;
}
.toasts .success-toast .message {
  grid-area: message;
}
/*# sourceMappingURL=toast.component.css.map */
